import Request from '@/utils/request'

export function getCompanyList(param) {
  return Request.post('/company/getCompanyList', param)
}

export function getCompanyDetail(param) {
  return Request.post('/company/getCompanyInfo/companyName', param)
}

export function uploadImg(param) {
  return Request.post('/upload/imgUpload', param)
}

export function uploadFile(param) {
  return Request.post('/upload/wordUpload', param)
}

// 获取案件概况
export function caseOverview(caseId) {
  return Request.get(`/case/overview/${caseId}`)
}

// 保存案件
export function saveCase(param) {
  return Request.post('/case/save', param)
}

// 提交案件
export function submitCase(param) {
  return Request.post('/case/submit', param)
}
